// Uma pergunta só: a tela é de celular?
//
// Existe porque a lista de mensagens é VIRTUALIZADA, e virtualização precisa
// saber a altura da linha em NÚMERO, antes de desenhar. Classe do Tailwind
// não serve: `sm:h-11` é CSS, e o virtualizador calcula em JavaScript quantas
// linhas cabem e onde cada uma começa. Com o número errado a lista fica com
// buracos ou com linhas sobrepostas.
//
// O limite é o mesmo `sm` do Tailwind (640px), escrito uma vez aqui. Dois
// limites diferentes — um no CSS, outro no JS — é como a linha ganha duas
// alturas ao mesmo tempo.

import { useEffect, useState } from "react";

const CELULAR = "(max-width: 639px)";

export function useCelular(): boolean {
  const [celular, setCelular] = useState(
    () => typeof window !== "undefined" && window.matchMedia(CELULAR).matches,
  );

  useEffect(() => {
    const consulta = window.matchMedia(CELULAR);
    const mudou = (e: MediaQueryListEvent) => setCelular(e.matches);
    consulta.addEventListener("change", mudou);
    // Girar o aparelho muda a resposta, e o estado inicial pode ter sido
    // calculado antes disso.
    setCelular(consulta.matches);
    return () => consulta.removeEventListener("change", mudou);
  }, []);

  return celular;
}
